import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontBold, fontExtraBold, maxZIndex } from 'style/styled-components/cssGlobalVariables';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import Button from 'components/Buttons/Button/Button';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(19, 19, 32, 0.95);
    overflow: auto;
    z-index: ${maxZIndex};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ModalContent = styled.div`
    width: 100%;
    max-width: 560px;
    max-height: 80vh;
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    text-align: center;

    ${MQ(Breakpoints.xs)} {
        padding: 32px;
    }
`;

export const ModalTitle = styled.h2`
    margin: 1em 0;
    font-family: ${fontExtraBold};
    font-weight: normal;
    font-size: 32px;
    line-height: 40px;
    color: var(--color-dark-body);
`;

export const ModalBodyText = styled.p`
    font-size: 16px;
    line-height: 24px;
    color: var(--color-dark-body-70);
    margin-top: 16px;
    opacity: 0.7;
`;

export const DeviceListContainer = styled.div`
    margin-top: 24px;
    overflow-y: auto;
    max-height: 40vh;
    text-align: left;
`;

export const ButtonContainer = styled.div`
    margin-top: 24px;
`;

export const ModalButton = styled(Button)`
    font-family: ${fontBold};
    width: 100%;

    ${MQ(Breakpoints.xs)} {
        width: auto;
    }
`;

export const LoadingText = styled.p`
    font-size: 16px;
    line-height: 24px;
    color: var(--color-dark-body-70);
    margin-top: 24px;
`;

export const ErrorText = styled.p`
    font-size: 16px;
    line-height: 24px;
    color: var(--color-dark-body-70);
    margin-top: 24px;
    opacity: 0.7;
`;
